module.exports = __webpack_public_path__ + "659e11e8641bc74a434b35554e0cd815.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Misc/verge.png
// module id = 648
// module chunks = 0